__turbopack_context__.v({
  "className": "gilda_display_f956b7c0-module__siAdPW__className",
  "variable": "gilda_display_f956b7c0-module__siAdPW__variable",
});
